import React, { forwardRef } from 'react';

import styled from '@emotion/styled';

import CalendarIcon from '../../../../components/Icons/CalendarIcon';
import CalenderModal from '../../../../components/Modal/ModalActions/CalenderModal';
import ModalTriggerContainer from '../../../../components/Modal/ModalTriggerContainer';
import { ModalProvider } from '../../../../context/ModalContext';
import { Modal } from '../../../../components/Modal/Modal';

const ApplicantCalendarModal = forwardRef<
  HTMLDivElement,
  { applicantId: string }
>(({ applicantId }, ref) => {
  return (
    <ModalProvider>
      <ModalTriggerContainer ref={ref}>
        <IconWrapper>
          <CalendarIcon />
        </IconWrapper>
      </ModalTriggerContainer>
      <Modal>
        <CalenderModal applicantId={applicantId} />
      </Modal>
    </ModalProvider>
  );
});

export default ApplicantCalendarModal;

const IconWrapper = styled.div`
  cursor: pointer;
`;
